import { FC, useState } from 'react'

import { InsuranceForm } from '@/screens/B2bInsurance/page/ui/InsuranceForm/InsuranceForm'

import NumberedList from '@/screensComponents/FinancialServices/NumberedList/NumberedList'
import { TableBlock } from '@/screensComponents/Insurances/TableBlock/TableBlock'
import { gridInfo } from '@/screensComponents/Insurances/TableBlock/TableData'

import { HeroBannerInfo } from '@/widgets/HeroBannerInfo'

import { Modal } from '@/shared/ui'
import { FaqSection } from '@/shared/ui/FaqSection'
import { HorizontalSection } from '@/shared/ui/HorizontalSection'
import { PdfList } from '@/shared/ui/PdfList'

import { faqItemsUr, heroBannerInfoData, pdfListUr, stepsItemsUr } from './data'

import cl from './styles.module.scss'

export const B2bInsurance: FC = () => {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<>
			<HeroBannerInfo {...heroBannerInfoData} onClick={() => setIsOpen(true)} />
			<NumberedList data={stepsItemsUr} className={cl.mb} />
			<TableBlock {...gridInfo} />
			<HorizontalSection title="Частые вопросы">
				<FaqSection items={faqItemsUr} />
			</HorizontalSection>
			<PdfList items={pdfListUr} />
			<Modal
				isOpen={isOpen}
				onClose={() => {
					setIsOpen(false)
				}}
				className={cl.modal}>
				<InsuranceForm />
			</Modal>
		</>
	)
}
